import { apiService } from "@/common/api.service.js";
export default {
  executeMeterHealthCheckQuery(payload) {
    let endpoint = `/api/meter-health-check/${payload.site_code}/`;
    return apiService(endpoint, "POST", payload);
  },
  meterHealthCheckList() {
      let endpoint = `/api/meter-health-check-list/`;
      return apiService(endpoint);
  },
  meterHealthCheckDashboards() {
    const endpoint = `/api/meter-health-check-dashboards/`;
    return apiService(endpoint);
  },
}